/**
 * Returns Formatted Phone Number (e.g. +1 (123) 456-7890
 * @param phone - Phone Number
 * @param fallbackCountryCode - Country code
 * @returns - Formatted Phone Number
 */
export const getFormattedPhoneNumber = (phone: string, fallbackCountryCode?: string) => {
  // getting valid E164 phone number and country dial code
  const [phoneCode, phoneNumber, phoneMask] = parseE164Phone(phone, fallbackCountryCode)
  if (!phoneNumber) return ''
  return `+${phoneCode} ${maskPhone(phoneNumber, phoneMask).formatted}`
}
